import React, { useState } from 'react';
import { Star, Trash2, GripVertical, Plus } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';
import TranslateButton from '../TranslateButton';
import { EditorCard, inputCls } from './ui';

const ORDINALS_AR = ['الأولى', 'الثانية', 'الثالثة', 'الرابعة', 'الخامسة', 'السادسة', 'السابعة', 'الثامنة', 'التاسعة', 'العاشرة'];

const move = (arr, from, to) => { const a = [...arr]; const [x] = a.splice(from, 1); a.splice(to, 0, x); return a; };

export const LearnPointsCard = ({ form, setForm, set }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const [drag, setDrag] = useState(null);
  const points = form.learnAr.map((ar, i) => ({ ar, en: form.learnEn[i] || '' }));
  const update = (list) => setForm(f => ({ ...f, learnAr: list.map(p => p.ar), learnEn: list.map(p => p.en) }));
  const fields = points.map((_, i) => ({ source: `learnAr.${i}`, target: `learnEn.${i}` }));
  return (
    <EditorCard testId="course-learn-card" Icon={Star} title={L('ماذا سيتعلم الطالب؟', 'What will students learn?')} desc={L('أضف أهم النقاط التي سيتعلمها الطالب في هذا الكورس', 'Add the key points students will learn')}
      action={points.length > 0 && <TranslateButton sourceLang="ar" targetLang="en" getValues={() => form} setValue={set} fields={fields} testId="course-learn-translate" />}>
      <div className="space-y-3">
        {points.map((p, i) => (
          <div key={i} data-testid={`learn-point-${i}`} draggable onDragStart={() => setDrag(i)} onDragOver={e => e.preventDefault()}
            onDrop={() => { if (drag !== null && drag !== i) update(move(points, drag, i)); setDrag(null); }}
            className={`rounded-xl transition-opacity ${drag === i ? 'opacity-40' : ''}`}>
            <div className="text-xs font-bold text-slate-600 mb-1.5">{L('النقطة', 'Point')} {lang === 'ar' ? (ORDINALS_AR[i] || i + 1) : i + 1}</div>
            <div className="flex items-start gap-2">
              <div className="flex-1 space-y-1.5">
                <input data-testid={`learn-point-ar-${i}`} dir="rtl" className={inputCls} placeholder={L('مثال: فهم أساسيات PLC وأنواعها', 'e.g. Understand PLC basics')} value={p.ar}
                  onChange={e => update(points.map((x, k) => (k === i ? { ...x, ar: e.target.value } : x)))} />
                <input data-testid={`learn-point-en-${i}`} dir="ltr" className={`${inputCls} h-9 text-xs bg-slate-50`} placeholder="English (optional)" value={p.en}
                  onChange={e => update(points.map((x, k) => (k === i ? { ...x, en: e.target.value } : x)))} />
              </div>
              <button type="button" data-testid={`learn-point-delete-${i}`} onClick={() => update(points.filter((_, k) => k !== i))} className="w-9 h-11 flex items-center justify-center rounded-lg text-slate-400 hover:text-rose-500 hover:bg-rose-50"><Trash2 className="w-4 h-4" /></button>
              <span className="w-6 h-11 flex items-center justify-center text-slate-300 cursor-grab active:cursor-grabbing" title={L('اسحب لإعادة الترتيب', 'Drag to reorder')}><GripVertical className="w-4 h-4" /></span>
            </div>
          </div>
        ))}
        <button type="button" data-testid="learn-point-add" onClick={() => update([...points, { ar: '', en: '' }])}
          className="w-full h-11 rounded-xl bg-slate-50 hover:bg-blue-50 text-blue-700 font-bold text-sm inline-flex items-center justify-center gap-1.5 transition-colors">
          <Plus className="w-4 h-4" />{L('إضافة نقطة جديدة', 'Add new point')}
        </button>
      </div>
    </EditorCard>
  );
};
